// SPDX-License-Identifier: MIT
// Pure session-boundary decision for the desktop build agent. A "session" is one
// Claude conversation thread (follow-ups use --continue). Bounding context = deciding
// when to start FRESH (no --continue). Hybrid policy: app-open OR manual OR threshold.
// No DOM / no Tauri → fully unit-tested.

export const SESSION_MAX_REQUESTS = 12;

export interface AgentRequest {
  id: string;
  prompt: string;
  kind: 'build' | 'followup';
  startedAt: string; // ISO
  lines: string[];   // raw NDJSON
}
export interface Session {
  id: string;
  startedAt: string; // ISO
  requests: AgentRequest[];
}

export interface DecideInput {
  current: Session | undefined;
  isAppFirstRun: boolean;
  manualReset: boolean;
  prompt: string;
  kind: 'build' | 'followup';
  now?: string;
  newId?: () => string;
}
export interface DecideOutput {
  fresh: boolean;
  thresholdHit: boolean;
  session: Session;
}

export function decideRun(input: DecideInput): DecideOutput {
  const now = input.now ?? '';
  let counter = 0;
  const newId = input.newId ?? (() => `${now}-${input.prompt.length}-${counter++}`);
  const req: AgentRequest = { id: newId(), prompt: input.prompt, kind: input.kind, startedAt: now, lines: [] };
  const thresholdHit = !!input.current && input.current.requests.length >= SESSION_MAX_REQUESTS;
  const fresh = !input.current || input.isAppFirstRun || input.manualReset || thresholdHit;
  if (fresh) {
    return { fresh: true, thresholdHit, session: { id: newId(), startedAt: now, requests: [req] } };
  }
  return { fresh: false, thresholdHit: false, session: { ...input.current!, requests: [...input.current!.requests, req] } };
}
